import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {RED_DARK} from 'ui-library/Colors';

export interface FieldErrorProps {
  message: string | null;
  // If compact, don't display bottom spacing. This is useful for putting fields in tables, for example.
  compact?: boolean;
}

/**
 * Component for rendering Benchling-styled error messages.
 */
export default function FieldError({compact = false, message = null}: FieldErrorProps): JSX.Element | null {
  return message == null ? null : (
    <div
      className={css(fieldErrorStyles.wrapper, compact && fieldErrorStyles.compact)}
      {...getTestProps({component: 'FieldError', element: 'root'})}
    >
      {message}
    </div>
  );
}

export const fieldErrorStyles = StyleSheet.create({
  wrapper: {
    color: RED_DARK,
    marginTop: 2,
    marginBottom: 8,
  },
  compact: {
    marginBottom: 0,
  },
});
